import { render, staticRenderFns } from "./MoveToCompanyPopup.vue?vue&type=template&id=508f143c&scoped=true&"
import script from "./MoveToCompanyPopup.vue?vue&type=script&lang=js&"
export * from "./MoveToCompanyPopup.vue?vue&type=script&lang=js&"
import style0 from "./MoveToCompanyPopup.vue?vue&type=style&index=0&id=508f143c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508f143c",
  null
  
)

export default component.exports